import { render, staticRenderFns } from "./Empresas.vue?vue&type=template&id=5fc7f539"
import script from "./Empresas.vue?vue&type=script&lang=js"
export * from "./Empresas.vue?vue&type=script&lang=js"
import style0 from "./Empresas.vue?vue&type=style&index=0&id=5fc7f539&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports